var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 6.68569H14.0625M4.91964 2.25V3.40728M12.5625 2.25V3.40714M14.8125 5.43214V13.725C14.8125 14.8434 13.9171 15.75 12.8125 15.75H4.8125C3.70793 15.75 2.8125 14.8434 2.8125 13.725V5.43214C2.8125 4.31376 3.70793 3.40714 4.8125 3.40714H12.8125C13.9171 3.40714 14.8125 4.31376 14.8125 5.43214Z",
    stroke: "#616874",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignCalendar);
export default __webpack_public_path__ + "static/media/campaignCalendar.7c765ff945de7f21b0f2c77e7577de3c.svg";
export { ForwardRef as ReactComponent };